import http from '@/http-common'
import PlaceSelect from '@/views/LocationPage.vue'
import SmetaForm from '@/components/Smeta.vue'
import PeopleSelect from '@/views/people/PeoplePage.vue'
import FileDocument from '@/components/FileDocument.vue'
import InputGroupForm from '@/components/InputGroupForm.vue'
import global from '@/utils/global'
import FileChange from '@/components/FileChange.vue'
import ModalEkp from '@/views/ekpForm/ModalFormEkp'
import ModalFilterEkp from '@/views/ekpForm/filter/ModalFilterEkp.vue'
import DocumentsEkp from '@/views/ekpForm/DocumentsEkp'
import tokenService from "@/services/token.service";
import EventService from "@/utils/services/eventService";
import EventEditForm from "@/views/ekpForm/edit/EventEditForm.vue";
import ResultTeam from "@/components/resultTeam/ResultTeam.vue";

export default {
    name: 'EkpTabPage',
    components: {
        PlaceSelect,
        SmetaForm,
        PeopleSelect,
        FileDocument,
        InputGroupForm,
        FileChange,
        ModalEkp,
        ModalFilterEkp,
        DocumentsEkp,
        EventEditForm,
        ResultTeam
    },
    data() {
        return {
            stacked: {
                type: Object,
                default: function () {
                    return {flg: false, size: 'sm', tdClass: 'bg-info'}
                }
            },
            currentPage: 1,
            isBusy: false,
            perPage: 10,
            // totalRows: 1,
            totalFiltered: 1,
            pageOptions: [10, 15, 20],
            filter: null,
            selectMode: 'single',
            selected: [],
            editItem: {id: null, location: ''},
            // showFilter: false,
            items: [],
            documents: [],
            excel_fields: [
                {field: 'orderNumber', label: 'Номер приказа'},
                {field: 'orderDate', label: 'Дата приказа'},
                {field: 'dateEvent', label: 'Дата проведения'},
                {field: 'nameEvent', label: 'Наименование мероприятия'},
                {field: 'held', label: 'Проведено', dataFormat: this.heldFormat},
                {field: 'eventState', label: 'Состояние'},
                {field: 'eventKind', label: 'Статус'},
                {field: 'ekpType', label: 'Вид ЕКП'},
                {field: 'jobKind', label: 'Вид работ'},
                {field: 'federation', label: 'Федерация'},
                {field: 'sportKind', label: 'Раздел ЕКП'},
                {field: 'location', label: 'Объект спорта'},
                {field: 'ageKind', label: 'Возраст/кат'},
                {field: 'count_people', label: 'Кол-во учас'},
                {field: 'summ', label: 'Сумма по ЕКП'},
                {field: 'summaSmeta', label: 'Сумма по смете'},
                {field: 'summaReturn', label: 'Возврат'},
                {field: 'summaBalance', label: 'Остаток'},
                {field: 'responsible', label: 'Ответственный'},
                {field: 'phoneTel', label: 'Телефон'},
                {field: 'description', label: 'Примечание'}
            ],
            columns: [
                {
                    key: 'dateEvent',
                    label: 'Дата проведения',
                    sortable: true,
                    sortByFormatted: true,
                    formatter: (value, key, item) => {
                        return item.dateBegin;
                    },
                    width: '80px'
                },
                {key: 'nameEvent', label: 'Наименование мероприятия', sortable: true},
                {key: 'heldCheck', label: 'Проведено', width: '50px'},
                {key: 'eventState', label: 'Состояние', sortable: true, width: '50px'},
                {key: 'eventKind', label: 'Статус', sortable: true, width: '150px'},
                {key: 'ekpType', label: 'Вид ЕКП', sortable: true, width: '100px'},
                {key: 'jobKind', label: 'Вид работ', sortable: true, width: '100px'},
                {key: 'federation', label: 'Федерация', sortable: true, width: '150px'},
                {key: 'sportKind', label: 'Раздел ЕКП', sortable: true, width: '150px'},
                {key: 'location', label: 'Объект спорта', sortable: true, width: '150px'},
                {key: 'ageKind', label: 'Возраст/кат', sortable: true, width: '150px'},
                {
                    key: 'count_people', label: 'Кол-во учас', sortable: true,
                    formatter: value => {
                        return value != null && value > 0 ? value : "";
                    }, width: '100px'
                },
                {
                    key: 'summ', label: 'Сумма по ЕКП', sortable: true,
                    formatter: value => {
                        return value != null && value > 0 ? value.toFixed(2) : "";
                    }, width: '80px'
                },
                {
                    key: 'summaSmeta', label: 'Сумма по смете', sortable: true,
                    formatter: value => {
                        return value != null && value > 0 ? value.toFixed(2) : "";
                    }, width: '80px'
                },
                {
                    key: 'summaReturn', label: 'Возврат', sortable: true,
                    formatter: value => {
                        return value != null && value > 0 ? value.toFixed(2) : "";
                    }
                },
                {
                    key: 'summaBalance', label: 'Остаток', sortable: true,
                    formatter: value => {
                        return value != null && value > 0 ? value.toFixed(2) : "";
                    }
                },
                {key: 'edit_field', label: ''}
            ],
            modalEditOpened: false,
            delete_dialog: false,
            modalSmetaOpened: false,
            smetaEkp: {
                id: 0,
                managerFIO: '',
                respFIO: '',
                details: []
            },
            modalDocumentOpened: false,
            modalFileDocumentOpened: false,
            modalTemplateOpened: false,
            modalLoadOpened: false,
            showOperation: false,
            validValue: {
                org: true,
                ekpT: true,
                eventKind: true, // вид ЕКП
                nameEvent: true, // наименование мероприятия
                federation: true, // федерация
                sportKind: true, // раздел ЕКП
                location: true, // место проведения
                jobKind: true, // вид работ
                ageKind: true, // возрастная категория
                summaEkp: true, // сумма
                countPeople: true, // кол-во участников
                summaAll: true,
                summaSmeta: true,
                form: true
            },
            fedList: [],
            locList: [],
            kindList: [],
            eventKinds: [],
            eventstateList: [],
            jobkindList: [],
            heldList: [
                {value: false, text: 'Нет'},
                {value: true, text: 'Да'}
            ],
            changeList: [
                {value: false, text: 'Нет'},
                {value: true, text: 'Есть'}
            ],
            heldValue: 'Провести',
            captionBtnSave: 'Сохранить',
            indexRow: 0,
            managerList: [],
            respList: [],
            dfileAct: '',
            dfileContract: '',
            dfileOrder: '',
            dfileStatement: '',
            downloadAct: '',
            downloadContract: '',
            downloadOrder: '',
            downloadStatement: '',
            summList: [
                {value: 1, text: 'Сумма по ЕКП'},
                {value: 2, text: 'Сумма по смете'},
                {value: 3, text: 'Остаток'},
            ],
            modalPdfDialogOpened: false,
            validDocument: {
                count: true,
                doc: true,
                date: true,
                form: true,
            },
            modalReportOpened: false,
            modalTemplateDocOpened: false,
            reportEkp: {},
            dismissSecs: 3,
            dismissCountDown: 0,
            file: '',
            selectedDoc: {},
            dfileDocument: '',
            downloadDocument: '',
            titlePeople: '',
            casePeople: 0,
            selectedPeople: {},
            columnsPeople: [
                {key: 'fio', label: 'ФИО'},
                {key: 'dolzhn', label: 'Дожность'},
                {key: 'edit_field', label: ''}
            ],
            modalPeopleOpened: false,
            modalResultOpened: false,
            sett: {percent: 1},
            limitYear: 0,
            allSummEkp: 0,
            oldSummEkp: 0,
            fileName: 'ЕКП таблица',
            ekpTypeList: [],
            orgList: [],
            summEkpAll: [],
            filteredItems: [],
            ageKindList: [],
            filterEkp: {
                dat1: null,
                dat2: null,
                organizationId: null,
                ekpTypeId: null,
                jobKindId: null,
                eventKindId: null,
                eventStateId: null,
                federationId: null,
                sportKindId: 0,
                locationId: 0,
                heldValue: null,
                changeValue: null,
                documentType: null,
                docTypeId: 0,
                docId: null,
                sumTypeId: 0,
                sum1: 0,
                sum2: 999999
            },
            widthModal70: '70%',
            widthOpeationModal: '20%',
            documentId: null,
            validDocumentId: false,
            docList: []
        }
    },
    created() {
        this.loadFilterFromStorage()
        this.loadFederations();
        this.loadLocation();
        this.loadKind();
        this.loadEventKind();
        this.loadEventState();
        this.loadOrgs();
        this.loadEkpTypes();
        this.loadJobKind();
        this.loadAgeKind()
        this.downloadFile = '';
        this.onResize();
        this.loadItems();
    },
    methods: {
        loadFilterFromStorage() {
            try {
                let filterStorage = tokenService.getEkpFilter()
                if (filterStorage != null) {
                    this.filterEkp = filterStorage
                }
                const dat = new Date();
                if (this.filterEkp != null && this.filterEkp.dat1 == null) {
                    this.filterEkp.dat1 = (dat.getFullYear()).toString() + "-01-01";
                }
                if (this.filterEkp != null && this.filterEkp.dat2 == null)
                    this.filterEkp.dat2 = (dat.getFullYear()).toString() + "-12-31";
                if (this.filterEkp != null && this.filterEkp.organizationId == null) {
                    let userInfo = tokenService.getUser();
                    let orgId = userInfo.orgId;
                    this.filterEkp.organizationId = orgId == null ? 1 : orgId;
                }
            } catch (err) {
                console.error('error: ' + err)
                return {
                    dat1: (new Date().getFullYear()).toString() + "-01-01",
                    dat2: (new Date().getFullYear()).toString() + "-12-31",
                    organizationId: 1
                }
            }
        },
        heldFormat(value) {
            if (value === true)
                return 'Проведен'
            else
                return ''
        },
        onFiltered(filteredItems) {
            this.filteredItems = filteredItems
            // this.totalFiltered = filteredItems.length;
        },
        getRespForReport() {
            if (this.editItem.smeta)
                return this.editItem.smeta.respFIO + ', тел. ' + (this.editItem.smeta.resp && this.editItem.smeta.resp.phoneTel ? this.editItem.smeta.resp.phoneTel : '')
            else return '';
        },
        updateRow(rec, addFlag) {
            const index = this.items.map(e => e.id).indexOf(rec.id);
            if (index >= 0) {
              for (let key in rec) {
                this.items[index][key] = rec[key];
              }
            }
            if (addFlag) {
              this.items.push(rec)
            }
        },
        onResize() {
            // Small (sm) <=540px
            if (document.documentElement.clientWidth > global.isMobileWidth()) {
                this.stacked.flg = false
                this.stacked.size = 'sm'
                this.columns.forEach(function (x) {
                    x.class = x.firstClass;
                })
                this.widthOpeationModal = '20%'
            } else {
                this.stacked.flg = true
                this.stacked.size = 'sm'
                this.columns.forEach(function (x) {
                    x.class = null;
                })
                this.columns[0].tdClass = 'bg-info'
                this.widthOpeationModal = '80%'
            }
        },
        getStacked() {
            if (this.stacked.flg) {
                return this.stacked.size;
            } else {
                return false;
            }
        },
        rowSelected(rows) {
            this.selected = rows;
            if (rows[0])
                this.editItem = JSON.parse(JSON.stringify(rows[0]));
        },
        cleanFilter() {
            let vm = this;
            const dat = new Date();
            vm.filterEkp.dat1 = (dat.getFullYear()).toString() + "-01-01";
            vm.filterEkp.dat2 = (dat.getFullYear()).toString() + "-12-31";
            vm.filterEkp.federationId = null;
            vm.filterEkp.eventKindId = null;
            vm.filterEkp.eventStateId = null;
            vm.filterEkp.heldValue = null;
            vm.filterEkp.changeValue = null;
            vm.filterEkp.sportKindId = 0;
            vm.filterEkp.locationId = 0;
            vm.filterEkp.sumType = 0;
            vm.filterEkp.ekpTypeId = null;
            vm.filterEkp.jobKindId = null;
            console.log("vm.filterEkp:" + vm.filterEkp)
            this.loadItems();
            this.showFilter = false
            tokenService.putEkpFilter(vm.filterEkp)
        },
        loadAgeKind() {
            let vm = this;
            vm.ageKindList = []
            let opt = {value: null, text: '-- Выберите возрастную категорию --', disabled: true}
            vm.ageKindList.push(opt);
            http.get('/workkind/AGE_KIND/list')
                .then((response) => {
                    response.data.forEach(function (x) {
                        var rec = {}
                        rec.value = x.id;
                        rec.text = x.shortName;
                        vm.ageKindList.push(rec);
                    })
                })
                .catch((error) => console.log(error.message))
            // .finally(() =>  vm.loadData.loadOrgs = false);
        },
        loadOrgs() {
            let vm = this;
            http.get('/org/list')
                .then((response) => {
                    vm.orgList = response.data;
                    vm.orgList.forEach(function (x) {
                        x.value = x.id;
                        x.text = x.shortName;
                    })
                })
                .catch((error) => console.log(error.message));
        },
        loadEkpTypes() {
            var vm = this;
            http.get('/workkind/EKP_TYPE/list')
                .then((response) => {
                    vm.ekpTypeList = response.data;
                    vm.ekpTypeList.forEach(function (x) {
                        x.value = x.id;
                        x.text = x.name;
                    })
                    if (!vm.editItem.id)
                        vm.editItem.ekptype_id = vm.ekpTypeList[0].id
                })
                .catch((error) => console.log(error.message));
        },
        loadItems() {
            let vm = this;
            this.modalLoadOpened = true;
            http.post('/ekp/list', vm.filterEkp)
                .then((response) => {
                    vm.items = response.data.obj;
                    vm.totalFiltered = response.data.size;
                    vm.items.forEach(function (x) {
                        x.formulaStr = '=RC[-3]-RC[-2]+RC[-1]';
                    })
                    vm.getSummEkp()
                    vm.onFiltered(vm.items)
                })
                .catch((error) =>
                    console.log(error.response)
                )
                .finally(() => {
                    vm.modalLoadOpened = false
                    vm.currentPage = 1
                });
            vm.showFilter = false;
        },
        loadReport(id) {
            var vm = this;
            http.get('/ekp/report/' + id)
                .then((response) => {
                    if (response.data && response.data !== "")
                        vm.reportEkp = response.data;
                    else
                        vm.cleanReport();
                })
                .catch((error) => console.log(error.message));
        },
        cleanItem() {
            for (var key in this.editItem) {
                if (typeof this.editItem[key] == 'string') {
                    this.editItem[key] = ''
                } else {
                    this.editItem[key] = null
                }
            }
        },
        cleanReport() {
            for (let key in this.reportEkp) {
                if (typeof this.reportEkp[key] == 'string') {
                    this.reportEkp[key] = ''
                } else {
                    this.reportEkp[key] = null
                }
            }
        },
        add() {
            if (this.items.length > 0)
                this.rowSelected([this.items[0]]);
            this.cleanItem();
            this.captionBtnSave = 'Добавить';
            this.showEditDialog()
        },
        editEkp() {
            this.showOperation = false;
            //this.rowSelected([rec]);
            this.captionBtnSave = 'Сохранить';
            this.showEditDialog()
        },
        showEditDialog() {
            // for (let key in this.validValue) {
            //     this.validValue[key] = true;
            // }
            if (this.editItem.held === true)
                this.heldValue = 'Отменить'
            else
                this.heldValue = 'Провести'
            // if (this.editItem.dateBegin) {
            //     let datStr = this.editItem.dateBegin;
            //     let dat = new Date(datStr);
            //     let year = dat.getFullYear();
            //     let orgId = this.editItem.organizationId;
            //     this.loadLimit(year, orgId, this.editItem.ekpTypeId);
            //     this.loadAllSumm(year, orgId, this.editItem.ekpTypeId);
            // }
            this.oldSummEkp = this.editItem.summ;

            this.loadEkpTypes();
            //this.loadOrgs();

            this.modalEditOpened = !this.modalEditOpened;
        },
        closeEditDialog() {
            this.modalEditOpened = false
        },
        loadFederations() {
            let vm = this;
            http.get('/federation/list')
                .then((response) => {
                    vm.fedList = response.data;
                    vm.fedList.forEach(function (x) {
                        x.value = x.id;
                        x.text = x.shortName;
                    })
                })
                .catch((error) => console.log(error.response.data));
        },
        loadLocation() {
            let vm = this;
            http.get('/location/list')
                .then((response) => {
                    vm.locList = response.data;
                    vm.locList.forEach(function (x) {
                        x.value = x.id;
                        x.text = x.nameObj;
                    })
                })
                .catch((error) => console.log(error.response.data));
        },
        loadKind() {
            var vm = this;
            http.get('/sportkind/list')
                .then((response) => {
                    vm.kindList = response.data;
                    vm.kindList.forEach(function (x) {
                        x.value = x.id;
                        x.text = x.name;
                    })
                })
                .catch((error) => console.log(error.response.data));
        },
        loadEventKind() {
            let vm = this;
            http.get('/eventkind/list')
                .then((response) => {
                    vm.eventKinds = response.data;
                    vm.eventKinds.forEach(function (x) {
                        x.value = x.id;
                        x.text = x.nameKind;
                    })
                })
                .catch((error) => console.log(error.response.data));
        },
        loadJobKind() {
            var vm = this;
            http.get('/workkind/JOB_KIND/option')
                .then((response) => {
                    vm.jobkindList = response.data;
                })
                .catch((error) => console.log(error.response.data));
        },
        loadEventState() {
            var vm = this;
            http.get('/eventstate/list')
                .then((response) => {
                    vm.eventstateList = response.data;
                    vm.eventstateList.forEach(function (x) {
                        x.value = x.id;
                        x.text = x.nameState;
                    })
                })
                .catch((error) => console.log(error.response.data));
        },
        addDocumentRow() {
            var doc = {
                id: 0,
                keyFile: Date.now(),
                ekpDataId: this.editItem.id,
                nameDoc: '',
                dateDoc: null
            }
            this.documents.push(doc);
        },
        showMenu(rec, index) {
            this.showOperation = !this.showOperation;
            this.indexRow = index;
            this.rowSelected([rec])
        },
        showSmeta() {
            this.showOperation = false;
            //this.rowSelected([rec]);
            //this.loadSmeta(this.editItem.id);
            //this.cleanSmeta();
            this.getSettPercent(this.editItem.organizationId);

            if (this.editItem.held === true)
                this.heldValue = 'Отменить'
            else
                this.heldValue = 'Провести'

            this.modalSmetaOpened = true
        },
        showReport() {
            this.showOperation = false;
            this.loadReport(this.editItem.id);
            this.modalReportOpened = !this.modalReportOpened
        },
        showFilterModal() {
            this.$refs.modalFilterEkp.showFilter = true
        },
        showDocument() {
            this.showOperation = false;
            for (var key in this.validDocument) {
                this.validDocument[key] = true;
            }
            //this.rowSelected([rec]);
            this.loadDocuments(this.editItem.id);
            this.modalDocumentOpened = !this.modalDocumentOpened
        },
        showFileDocument() {
            this.showOperation = false;
            for (var key in this.validDocument) {
                this.validDocument[key] = true;
            }
            //this.rowSelected([rec]);
            this.modalFileDocumentOpened = !this.modalFileDocumentOpened
        },
        showFiles() {
            this.$refs.modalDocumentEkp.openModal();
            this.showOperation = false;
        },
        showResult() {
            this.modalResultOpened = !this.modalResultOpened
            this.showOperation = false;
        },
        //saveDocuments() {
        //this.modalDocumentOpened = !this.modalDocumentOpened;
//        this.checkDocuments();
//        if (this.validDocument.form) {
//          http.post('/ekp/doc/save/'+this.editItem.id, this.documents)
//            .then((response) => {
//              this.modalDocumentOpened = !this.modalDocumentOpened;
//            })
//            .catch(error => {
//              if (error.response.status == 403)
//                alert("Нет прав!")
//              else
//                alert(error.response.message)
//            });
//        }
        //},
//      deleteRowDoc(index) {
//        this.documents.splice(index,1)
//      },
//      showPdfDialog(item, index) {
//        this.selectedDoc = JSON.parse(JSON.stringify(item));
//        this.dfileDocument = '';
//        this.downloadDocument = '';
//        this.checkPdfExists();
//        this.activeIndexDoc = index;
//        this.modalPdfDialogOpened = !this.modalPdfDialogOpened;
//      },
        loadDocuments(id) {
            let vm = this;
            http.get('/ekp/doc/' + id)
                .then((response) => {
                    if (response.data && response.data !== "")
                        vm.documents = response.data;
                    else
                        vm.documents = []
                })
                .catch((error) => console.log(error.response.data));
        },
        loadDocumentsEkp(id) {
            let vm = this;
            http.get('/docEkp/change/' + id)
                .then((response) => {
                    vm.docList = []
                    if (response.data && response.data !== "")
                        response.data.forEach(function (x) {
                            let obj = {value: x.id, text: x.nameDoc};
                            vm.docList.push(obj);
                        })
                })
                .catch((error) => console.log(error.response.data));
        },
        showConfirmDlg() {
            this.showOperation = false;
            // this.rowSelected([rec]);
            //this.indexRow = index;
            this.loadDocumentsEkp(this.editItem.id);
            this.delete_dialog = true;
        },
        checkSelectDocument() {
            this.validDocumentId = !(this.documentId === null || this.documentId === 0);
        },
        deleteEkp() {
            let vm = this;
            if (vm.validDocumentId) {
                http.delete('/ekp/' + this.editItem.id + "?doc_id=" + vm.documentId)
                    .then((res) => {
                        let result = res.data;
                        if (result === "success") {
                            vm.items.splice(vm.indexRow, 1)
                        } else {
                            alert("Ошибка удаления позиции!!!")
                        }
                    })
                    .catch((error) => {
                        if (error.response.status === 403)
                            alert("Нет прав!")
                        else
                            alert(error.response.data)
                    })
                    .finally(() => this.delete_dialog = false);
            }
        },
        exportAct() {
            this.downloadAct = '';
            if (this.smetaEkp.respFIO && this.smetaEkp.respFIO !== '') {
                http.get('/report/shablon?id=' + this.smetaEkp.id + "&type=1")
                    .then((response) => {
                        if (response.data.ok && response.data.name !== '') {
                            this.downloadAct = '/report/download?name=' + encodeURIComponent(response.data.name);
                            this.dfileAct = 'Акт.docx';
                            this.showAlert();
                        } else {
                            alert("Акт не сформирована!");
                        }
                    })
                    .catch((error) => {
                        if (error.response.data === "no exists")
                            alert("Шаблон Акта не существует!");
                        else
                            alert(error.message);
                    });
            } else
                alert("Не заполнено поле Ответственный!");
        },
        exportContract() {
            this.downloadContract = '';
            if (this.smetaEkp.respFIO && this.smetaEkp.respFIO !== '') {
                http.get('/report/shablon?id=' + this.smetaEkp.id + "&type=0")
                    .then((response) => {
                        if (response.data.ok && response.data.name !== '') {
                            this.downloadContract = '/report/download?name=' + encodeURIComponent(response.data.name);
                            this.dfileContract = 'Договор.docx';
                            this.showAlert();
                        } else {
                            alert("Договор не сформирован!");
                        }
                    })
                    .catch((error) => {
                        if (error.response.data === "no exists")
                            alert("Шаблон Договора не существует!");
                        else
                            alert(error.response.data);
                    });
            } else
                alert("Не заполнено поле Ответственный!");
        },
        exportOrder() {
            this.downloadOrder = '';
            if (this.smetaEkp.respFIO && this.smetaEkp.respFIO !== '') {
                http.get('/report/shablon?id=' + this.smetaEkp.id + "&type=2")
                    .then((response) => {
                        if (response.data.ok && response.data.name !== '') {
                            this.downloadOrder = '/report/download?name=' + encodeURIComponent(response.data.name);
                            this.dfileOrder = 'Приказ.docx';
                            this.showAlert();
                        } else {
                            alert("Приказ не сформирован!");
                        }
                    })
                    .catch((error) => {
                        if (error.response.data === "no exists")
                            alert("Шаблон Приказа не существует!");
                        else
                            alert(error.response.data);
                    });
            } else
                alert("Не заполнено поле Ответственный!");
        },
        exportStatement() {
            this.downloadStatement = '';
            if (this.smetaEkp.respFIO && this.smetaEkp.respFIO !== '') {
                http.get('/report/shablon?id=' + this.smetaEkp.id + "&type=3")
                    .then((response) => {
                        if (response.data.ok && response.data.name !== '') {
                            this.downloadStatement = '/report/download?name=' + encodeURIComponent(response.data.name);
                            this.dfileStatement = 'Заявление.docx';
                            this.showAlert();
                        } else {
                            alert("Заявление не сформировано!");
                        }
                    })
                    .catch((error) => {
                        if (error.response.data === "no exists")
                            alert("Шаблон Заявления не существует!");
                        else
                            alert(error.response.data);
                    });
            } else
                alert("Не заполнено поле Ответственный!");
        },
        saveReport() {
            this.reportEkp.ekp_id = this.editItem.id;
            http.post('/ekp/report', this.reportEkp)
                .then(() => {
                    this.modalReportOpened = !this.modalReportOpened;
                })
                .catch(error => {
                    if (error.response.status === 403)
                        alert("Нет прав!")
                    else
                        alert(error.message)
                });
        },
        showTempBtn() {
            this.dfileAct = '';
            this.dfileOrder = '';
            this.dfileContract = '';
            this.dfileStatement = '';
            this.downloadAct = '';
            this.downloadOrder = '';
            this.downloadContract = '';
            this.downloadStatement = '';
            this.modalTemplateOpened = true
        },
        showPeopleDialog(i) {
            this.casePeople = i;
            switch (i) {
                case 1:
                    this.titlePeople = 'Укажите менеджера';
                    break;
                case 2:
                    this.titlePeople = 'Укажите ответственного';
                    break;
            }
            this.modalPeopleOpened = !this.modalPeopleOpened;
        },
        selectPeople() {
            switch (this.casePeople) {
                case 1:
                    this.$refs.smeta.smetaEkp.managerFIO = this.selectedPeople.fio;
                    this.$refs.smeta.smetaEkp.manager_id = this.selectedPeople.id;
                    break;
                case 2:
                    this.$refs.smeta.smetaEkp.respFIO = this.selectedPeople.fio;
                    this.$refs.smeta.smetaEkp.resp_id = this.selectedPeople.id;
                    break;
            }
            this.modalPeopleOpened = false;
        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        showAlert() {
            this.dismissCountDown = this.dismissSecs
        },
        changeHeld(held) {
            this.editItem.held = held;
            if (held === true)
                this.heldValue = 'Отменить'
            else
                this.heldValue = 'Провести';
            if (this.editItem.id > 0) {
                const index = this.items.map(e => e.id).indexOf(this.editItem.id);
                if (index >= 0) {
                    this.items[index].held = held;
                }
            }
        },
        changeSummaSmeta(summa, returnSum) {
            const index = this.items.map(e => e.id).indexOf(this.editItem.id);
            if (index >= 0) {
                this.items[index].summaSmeta = summa;
                this.items[index].summaReturn = returnSum;
                this.items[index].summaBalance = this.items[index].summ - summa;
            }
        },
        getSummEkp() {
            this.summEkpAll = ['', '', ''];
            if (this.items) {
                let summ1 = 0
                let summ2 = 0
                let summ3 = 0
                this.items.forEach(function (x) {
                    summ1 += x.summ;
                    summ2 += x.summaSmeta;
                    summ3 += (x.summ - x.summaSmeta)
                })
                this.summEkpAll = [
                    new Intl.NumberFormat('ru-RU').format(summ1) + ' руб.',
                    new Intl.NumberFormat('ru-RU').format(summ2) + ' руб.',
                    new Intl.NumberFormat('ru-RU').format(summ3) + ' руб.']
            }
        },
        getStyleModal: function () {
            return "min-width: 100vw; max-width: 100vw; mim-width: 50vh;";
        },
        getSettPercent(orgId) {
            let vm = this;
            EventService.getSettPercent(orgId)
                .then((response) => {
                    if (response.data != null && response.data !== "")
                        vm.sett = response.data;
                })
        },
        loadLimit(plan_year, orgId, ekpTypeId) {
            var vm = this;
            http.get('/limit/' + plan_year + '/' + orgId + '/' + vm.editItem.sportKindId + '?ekptype_id=' + ekpTypeId)
                .then((response) => {
                    vm.limitYear = response.data.summLimit;
                })
                .catch((error) => console.log(error.message));
        },
        // loadAllSumm(plan_year, orgId, ekpTypeId) {
        //     var vm = this;
        //     http.get('/ekp/allSumm/' + plan_year + '/' + orgId + '?ekptype_id=' + ekpTypeId + '&sportKindId=' + vm.editItem.sportKindId)
        //         .then((response) => {
        //             var dataSum = response.data;
        //             vm.allSummEkp = parseFloat(dataSum.summEkp);
        //         })
        //         .catch((error) => console.log(error.message));
        // },
        getLimitInfo() {
            var str = '';
            if (this.allSummEkp) str = "Общая сумма за год = " + this.allSummEkp.toFixed(2) + '; ';
            if (this.limitYear) str += "Лимит на год = " + this.limitYear.toFixed(2) + '; ';
            if (this.limitYear && this.allSummEkp)
                str += "Остаток на год = " + (this.limitYear - this.allSummEkp).toFixed(2) + ';';
            return str;
        },
        getMinDate() {
            if (this.editItem.dateBegin > this.editItem.dateEnd && this.editItem.dateEnd)
                return this.editItem.dateBegin
        },
        getColorCell(item) {
            if (item.colorBack || item.colorFont) {
                return 'background: ' + item.colorBack + '; color: ' + item.colorFont + ';';
            } else {
                return 'color: white;';
            }
        },
        formulaFormat() {
            return '=RC[-1]+RC[-2]'
        },
        downloadDocs(n) {
            var vm = this;
            this.modalLoadOpened = true;
            var dfile = '';
            var urlFile = '';
            switch (n) {
                case 0://Договор
                    dfile = vm.dfileContract;
                    urlFile = vm.downloadContract
                    break;
                case 1://Акт
                    dfile = vm.dfileAct;
                    urlFile = vm.downloadAct
                    break;
                case 2://Приказ
                    dfile = vm.dfileOrder;
                    urlFile = vm.downloadOrder
                    break;
                case 3://Заявление
                    dfile = vm.dfileStatement;
                    urlFile = vm.downloadStatement
                    break;
            }

            http.get(urlFile,
                {
                    responseType: 'arraybuffer',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/docx'
                    }
                }
            ).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', dfile); //or any other extension
                document.body.appendChild(link);
                link.click();
            }).finally(() => vm.modalLoadOpened = false);
        },
        getWidthModal(val) {
            return val.toString() + '%'
        },
        getTooltip(rec) {
            return rec.description ? 'Примечание: <em>' + rec.description + '</em>' : '';
        }
    },
    computed: {
        // modalFilterEkp() {
        //     return modalFilterEkp
        // },
        getBack() {
            return "background: rgba(255, 255, 150, 0.8);"
        },
        computedFields() {
            return this.columns.map(field => (
                field.width ? {
                    ...field,
                    thStyle: {width: field.width, minWidth: field.width},
                    tdAttr: {style: `max-width: ${field.width}; overflow: hidden;`}
                } : {...field}
            ))
        }
        // rows(items) {
        //     if (items)
        //         this.
        //     else
        //         return this.items.length
        // }
    }

}
